import React from "react";
import DataTable from "../../components/dataTable";
import { GridColumn as Column } from "@progress/kendo-react-grid";
import { getUserCredential, getTenantCookieData } from "../../lib/cookies";
import { DEFAULT_SORT } from "../../constants/grid";
import { columnMenuProps } from "../../components/customColumnMenu";
import { useDispatch } from "react-redux";
import { getfilterDataString, getGridHeight } from "../../utils/utils";
import { Window, WindowActionsBar } from "@progress/kendo-react-dialogs";
import { Button, ButtonGroup } from "@progress/kendo-react-buttons";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { DAYS_OF_WEEK, MONTH_OF_YEAR } from "src/constants/constants";
import { Error, Label, Info } from "@progress/kendo-react-labels";
import useAPI from "./jobDetailService";
import CustomDropdown from "src/components/customDropdown";
import { FieldWrapper, FormElement } from "@progress/kendo-react-form";
import { NumericTextBox, Checkbox } from "@progress/kendo-react-inputs";
import { DatePicker, TimePicker } from "@progress/kendo-react-dateinputs";
import MultiSelectDropdown from "../../components/multiSelect";
import { GetPositionDataAPI, GetSystemConfigData } from "../../lib/common-service";
import { CellRender, RowRender } from "../../components/renderers";
import MessageSchema from "../../utils/messageSchema";
import { useHistory } from "react-router-dom";
import { transformDateTime } from "src/lib/date-time.util";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { filterBy, orderBy } from "@progress/kendo-data-query";
import { process } from "@progress/kendo-data-query";

const loadingPanel = (
  <div className="k-loading-mask">
    <span className="k-loading-text">Loading</span>
    <div className="k-loading-image"></div>
    <div className="k-loading-color"></div>
  </div>
);
const initialFormFields = {
  in_start_date: "",
  in_start_time: "",
  in_period_mstr_key: "",
  in_position_keys: [],
  is_recurring_type_job: false,
  in_separation_count: 1,
  is_repet_job: "",
  in_recurring_end_date: "",
  in_day_of_month: 1,
  in_month_of_year: MONTH_OF_YEAR[0],
  compPlanValue: [],
  is_final_pay_period: false,
};

const editField = "inEdit";

const JobDetails = (restProps) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const defaultPageSize = getTenantCookieData("record_per_page");
  const DataItem = restProps?.dataItemList || {};

  const [pageData, setPage] = React.useState({
    skip: 0,
    take: defaultPageSize.recordTake,
  });
  const [pageSize, setPageSize] = React.useState(defaultPageSize);
  const [visible, setVisible] = React.useState(restProps.visible);
  const [data, setData] = React.useState([]);
  const cookiesData = getUserCredential();
  const [exportData, setExportData] = React.useState([]);
  const [formFields, setFormFields] = React.useState({
    ...initialFormFields,
  });
  const [isPostionButton, setIsPostionButton] = React.useState(true);
  const [isCompPostionButton, setIsCompPostionButton] = React.useState(true);

  const [errorObj, setErrorObj] = React.useState({});
  const [isSaveClick, setSaveClick] = React.useState(false);
  const [modal, setModal] = React.useState(true);
  const [stageChange, setStateChange] = React.useState("DEFAULT");
  const [isHeaderChecked, setIsHeaderChecked] = React.useState(false);
  const [resetSort, setResetSort] = React.useState(false);
  const [dataLengthbyFilter, setDataLengthbyFilter] = React.useState(null);
  const [databyFilter, setDatabyFilter] = React.useState(null);
  const [positionPopup, showPositionPopup] = React.useState(false);
  const [isPoistionIntialNote, showisPoistionIntialNote] = React.useState(false);
  const [isAllDataChecked, setIsAllDataChecked] = React.useState(false);
  const [isCheckBoxChange, setIsCheckBoxChange] = React.useState(false);
  const currentMonth = new Date().getMonth() + 1; // getMonth() returns 0-11, so we add 1
  const currentMonthMaxDays = MONTH_OF_YEAR.find((month) => month.value === currentMonth).maxDays;
  //state to set and get filter, sort number, sort order
  const [filterData, setFilterData] = React.useState({
    isSort: false,
    isFilter: false,
    data: "",
    in_sort_number: DEFAULT_SORT.number,
    sort_order: DEFAULT_SORT.order,
    filterString: "",
  });

  const [positionFilterData, setPositionFilterData] = React.useState({
    in_job_mstr_key: restProps.jobMstrKey,
    [DataItem.job_type_code === "email_process" ? "in_stagehook_job_mstr_key" : "in_comp_plan_mstr_key"]:
      DataItem.job_type_code === "email_process" ? DataItem.stagehook_mstr_key : DataItem.comp_plan_keys,
    in_filter: null,
    in_sort_number: DEFAULT_SORT.number,
    in_sort_order: DEFAULT_SORT.order,
    in_is_published: 0,
    job_type_code: DataItem.job_type_code,
  });

  const [filterField, setFilterField] = React.useState({
    logic: "and",
    filters: [],
  });
  const [sortField, setSortField] = React.useState([]);
  const [isRecurringTypeListshow, setisRecurringTypeListshow] = React.useState(false);

  const [isRecurringTypeWeekly, setIsRecurringTypeWeekly] = React.useState(false);
  const [isRecurringTypeMonthly, setIsRecurringTypeMonthly] = React.useState(false);
  const [isRecurringTypeYearly, setIsRecurringTypeYearly] = React.useState(false);
  const [selectedDays, setSelectedDays] = React.useState([]);
  const [maxDays, setMaxDays] = React.useState(currentMonthMaxDays);
  const [onOpenDp, setonOpenDp] = React.useState(false);
  const [sortFieldValue, setSortFieldValue] = React.useState([]);
  const [intialFilterCheck, setIntialFilterCheck] = React.useState(false);
  const [isPeriodFilter, setIsPeriodFilter] = React.useState(false);

  /** Use API Hooks */
  const [list, Action] = useAPI();
  const [gridState, setGridState] = React.useState({
    skip: pageData.skip,
    take: pageData.take, // Number of rows per page
    filter: null, // Initial filter state
    sort: [], // Initial sort state
  });
  const [gridHeight, setGridHeight] = React.useState("auto");
  const {
    postioncolumns,
    postionData,
    setPostionData,
    postionCount,
    originPeriod,
    periodsFields,
    setPeriodFields,
    originPeriodType,
    periodsTypeFields,
    setPeriodTypeFields,
    originCompPlan,
    compPlanFields,
    setcompPlanFields,
    isCompPlanDisable,
    setIsCompPlanDisable,
    isPostionAPICalling,
    initialPostionLoading,
    setPostionAPICallingState,
    recurringTypeFields,
    setRecurringTypeFields,
    originRecurringType,
    isRefreshLoading,
    setDataCount,
    dataCount,
    originalData,
    postionIsintail,
    setOriginalData,
  } = list;

  const ModalTitle = () => {
    let jobName = restProps.dataItemList.job_name;
    let jobTypeName = restProps.dataItemList.job_type_name;
    return (
      <>
        <span className="custtableflex">
          <div className="custtableitem">{jobName}</div>
          <span className="custtableseprator"> &gt; </span>
          <span> {jobTypeName} Job</span>
        </span>
      </>
    );
  };

  const processedData = process(postionData, {
    filter: gridState.filter,
    skip: gridState.skip,
    take: gridState.take,
    sort: gridState.sort,
  });

  React.useEffect(async () => {
    if (DataItem?.plan_param > 0) {
      const compPlanData = await Action.getCompPlanData({
        in_job_mstr_key: restProps.jobMstrKey,
      });

      if (DataItem?.position_param > 0) {
        if (compPlanData?.default?.length) {
          setIsCompPostionButton(false);
        } else {
          setIsCompPlanDisable(true);
        }
      }
    }

    await Action.getPeriodTypesData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    if (!onOpenDp && !isPeriodFilter) {
      const shouldCallPositionData =
        (DataItem?.position_param > 0 ||
          DataItem?.published_position > 0 ||
          DataItem?.job_type_code === "email_process") &&
        periodsFields.periodsData.length > 0;

      if (shouldCallPositionData) {
        setFilterData({
          ...filterData,
          isSort: false,
          data: "",
          isFilter: false,
          in_sort_number: DEFAULT_SORT.number,
          in_sort_order: DEFAULT_SORT.order,
        });
        setPage({ skip: 0, take: pageSize.recordTake });

        resetSort && setResetSort(false);
        isCheckBoxChange && setIsCheckBoxChange(false);

        const postionReqData = {
          ...positionFilterData,
          in_period_mstr_key: periodsFields.periodsValue.id,
        };
        getPostiongridData(postionReqData);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [periodsFields]);

  React.useEffect(() => {
    setkHeaderCheckbox();
  }, [postionData, gridState]);

  React.useEffect(() => {
    if (compPlanFields?.compPlanValue) {
      setFormFields({ ...formFields, compPlanValue: compPlanFields?.compPlanValue });
    }
  }, [compPlanFields.compPlanValue]);

  const handleRedirect = () => {
    history.push("/pipeline"); // Replace with your target route
  };

  const handleFinalPayPeriod = (event) => {
    setFormFields({ ...formFields, is_final_pay_period: event.value });
  };

  const handleRecurringCheckboxChange = (event) => {
    setFormFields({ ...formFields, is_recurring_type_job: event.value });
    Action.getRecurringTypesData();
    event.value === true ? setisRecurringTypeListshow(true) : setisRecurringTypeListshow(false);
    if (event.value === false) {
      setFormFields(initialFormFields);
      setIsRecurringTypeMonthly(false);
      setIsRecurringTypeWeekly(false);
      setIsRecurringTypeYearly(false);
      setSelectedDays([]);
    }
  };

  const handleRecurringDateChange = (event) => {
    setFormFields({
      ...formFields,
      in_recurring_end_date: event.target.value,
    });
  };

  const handleDateChange = (event) => {
    setonOpenDp(false);
    setFormFields({ ...formFields, in_start_date: event.target.value });
  };

  const handleFieldChange = (e) => {
    setonOpenDp(false);
    const name = e.name ? e.name : e.target.name;
    setFormFields({
      ...formFields,
      [name]: e.value,
    });
    setErrorObj({ ...errorObj, [name]: "" });

    setFormFields({ ...formFields, [name]: e.value });
  };

  const weekButtonClick = (value) => {
    if (selectedDays.includes(value)) {
      setSelectedDays(selectedDays.filter((day) => day !== value)); // Deselect if already selected
    } else {
      setSelectedDays([...selectedDays, value]); // Select if not already selected
    }
  };

  const isDaySelected = (value) => {
    return selectedDays.includes(value);
  };

  const onClosePopup = () => {
    setVisible(!visible);
    restProps.setIsAddJobtoQueue(false);
    setSaveClick(false);
    setErrorObj({});
    setFormFields(initialFormFields);
  };

  const cancelPositionPopup = () => {
    showPositionPopup(false);
  };
  function getWeekAndDay(dayOfMonth, month) {
    if (dayOfMonth === "") {
      return { weekOfMonth: 0, dayOfWeek: 0 };
    }
    const date = new Date();

    if (month !== null) {
      date.setFullYear(new Date().getFullYear(), month - 1, dayOfMonth);
    } else {
      date.setFullYear(new Date().getFullYear(), date.getMonth(), dayOfMonth);
    }

    const firstDayOfMonth = new Date(date.getFullYear(), date.getMonth(), 1).getDay();
    const weekNumber = Math.ceil((dayOfMonth + firstDayOfMonth) / 7);
    const dayOfWeek = DAYS_OF_WEEK[date.getDay()].value;

    return { weekOfMonth: weekNumber, dayOfWeek: dayOfWeek };
  }
  function convertIdsToCommaSeparatedString(inputArray) {
    const idArray = inputArray.map((item) => item.id);
    return idArray.join(",");
  }
  const handleMonthChange = (e) => {
    setonOpenDp(false);
    const selectedMonth = MONTH_OF_YEAR.find((month) => month.value === e.target.value.value);
    setFormFields({
      ...formFields,
      in_month_of_year: e.target.value,
      in_day_of_month: 1,
    });
    setMaxDays(selectedMonth ? selectedMonth.maxDays : 31);
  };
  const ShowError = React.useCallback(
    (props) => {
      return <Error>{errorObj[props.name]}</Error>;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [errorObj, isSaveClick]
  );
  const { job_type_code, plan_param } = restProps.dataItemList;

  const handleValidation = () => {
    let isValid = true;
    if (formFields.is_recurring_type_job === true) {
      if (formFields.in_start_date === "") {
        isValid = false;
        errorObj.in_start_date = MessageSchema.actionStartDateRequired;
      }
      if (formFields.in_start_time === "") {
        isValid = false;
        errorObj.in_start_time = MessageSchema.actionStartTimeRequired;
      }

      if (formFields.in_recurring_end_date === "") {
        isValid = false;
        errorObj.in_recurring_end_date = MessageSchema.actionEndDateRequired;
      }

      if (formFields.in_start_date > formFields.in_recurring_end_date) {
        isValid = false;
        errorObj.in_recurring_end_date = MessageSchema.maxEndDate;
      }

      if (
        formFields.in_day_of_month === null &&
        (recurringTypeFields.recurringTypeValue.text === "Year" ||
          recurringTypeFields.recurringTypeValue.text === "Month")
      ) {
        isValid = false;
        errorObj.in_day_of_month = MessageSchema.jobMonthNameRequired;
      }
    }

    if (
      job_type_code === "stage_hook" &&
      plan_param === 1 &&
      !postionData.length &&
      !formFields?.compPlanValue?.length
    ) {
      isValid = false;
      errorObj.compPlanValue = MessageSchema.jobCompPlanRequired;
    }

    setErrorObj((preVState) => ({ ...preVState, errorObj }));

    return isValid;
  };

  const handleAddJobtoQueue = async () => {
    let valid = handleValidation();

    if (valid) {
      setErrorObj({});
      let postionDataArray = [];
      let finalPositionData =
        databyFilter !== null && databyFilter && databyFilter.length > 0 ? databyFilter : postionData;

      const compPlanKeys =
        compPlanFields.compPlanValue.length > 0 ? convertIdsToCommaSeparatedString(compPlanFields.compPlanValue) : null;

      if (!compPlanKeys) {
        if (postionData.every((x) => x.is_assign === 0)) {
          postionData.map((item) => {
            let obj = {};
            obj.id =
              DataItem.job_type_code === "email_process" ? item.job_queue_param_assign_mstr_key : item.org_position_key;
            postionDataArray.push(obj);

            return 0;
          });
        } else {
          postionData
            .filter((x) => x.is_assign === 1)
            .map((item) => {
              let obj = {};
              obj.id =
                restProps.dataItemList.job_type_code === "email_process"
                  ? item.job_queue_param_assign_mstr_key
                  : item.org_position_key;
              postionDataArray.push(obj);

              return 0;
            });
        }
      }

      let dataObject = {
        in_tenant_id: cookiesData.out_tenant_id,
        in_filter: "AND system_pref_code = 'sys_time_zone'",
        in_sort_number: null,
        in_sort_order: null,
        in_page_row_offset: null,
        in_page_rows: null,
      };
      const resDataObject = await GetSystemConfigData(dataObject, dispatch);

      const { weekOfMonth, dayOfWeek } = getWeekAndDay(
        formFields.in_day_of_month,
        formFields.in_month_of_year.value !== undefined ? formFields.in_month_of_year.value : null
      );
      const startDate = formFields.in_start_date;
      const startTime = formFields.in_start_time;
      let formattedDate = "";
      if (startDate !== "" && startTime !== "") {
        const year = startDate.getFullYear();
        const month = startDate.getMonth();
        const date = startDate.getDate();

        // Extract the time parts
        const hours = startTime.getHours();
        const minutes = startTime.getMinutes();
        const seconds = startTime.getSeconds();

        // Combine date and time into a single Date object
        const combinedDate = new Date(year, month, date, hours, minutes, seconds);
        formattedDate = transformDateTime({
          date: combinedDate,
          format: "YYYY-MM-DD",
          includeTime: true,
        });
      } else if (startDate !== "") {
        const year = startDate.getFullYear();
        const month = startDate.getMonth();
        const date = startDate.getDate();

        // Combine date and time into a single Date object
        const combinedDate = new Date(year, month, date);
        formattedDate = transformDateTime({
          date: combinedDate,
          format: "YYYY-MM-DD",
          includeTime: true,
        });
      }

      if (
        (processedData.data.length > 0 &&
          postionDataArray.length === 0 &&
          restProps.dataItemList.job_type_code === "email_process") ||
        (restProps.dataItemList.position_param === 1 &&
          processedData.data.length > 0 &&
          postionDataArray.length === 0 &&
          restProps.dataItemList.job_type_code === "report_publish")
      ) {
        showPositionPopup(true);
      } else {
        const insertRecurringJobData = {
          in_user_id: cookiesData.out_user_id,
          in_tenant_id: cookiesData.out_tenant_id,
          in_job_mstr_key: restProps.jobMstrKey,
          in_period_mstr_key: periodsFields.periodsValue.id,
          in_start_date_time: formFields.in_start_date === "" ? "" : formattedDate,
          in_end_date_time:
            formFields.in_recurring_end_date === ""
              ? ""
              : transformDateTime({
                date: formFields.in_recurring_end_date,
                format: "YYYY-MM-DD HH:mm:ss",
              }),
          in_is_recurring: formFields.is_recurring_type_job === true ? "Y" : "N",
          in_recurring_type_mstr_key: recurringTypeFields.recurringTypeValue.id,
          in_separation_count: formFields.in_separation_count,
          in_day_of_week:
            recurringTypeFields.recurringTypeValue.id === 3
              ? selectedDays.map((item) => {
                return { day: item };
              })
              : dayOfWeek !== 0
                ? dayOfWeek
                : "",
          in_week_of_month: weekOfMonth,
          in_day_of_month: formFields.in_day_of_month,
          in_month_of_year: formFields.in_month_of_year.value !== undefined ? formFields.in_month_of_year.value : 0,
          in_param_src_mstr_key:
            postionDataArray.length > 0 ? convertIdsToCommaSeparatedString(postionDataArray) : null,
          in_job_queue_param_mstr_key:
            restProps.dataItemList.job_param === "Position" ? restProps.dataItemList.jobQueueParamKey : null,
          in_batch_name:
            restProps.dataItemList.comp_plan_name +
            periodsFields.periodsValue.text +
            restProps.dataItemList.job_type_code,
        };

        const bodyData = {
          in_user_id: cookiesData.out_user_id,
          in_tenant_id: cookiesData.out_tenant_id,
          in_job_mstr_key: restProps.jobMstrKey,
          in_period_mstr_key: periodsFields.periodsValue.id,
          in_time_interval: formFields.in_start_date === "" ? "" : formattedDate,
          in_comp_plan_keys: compPlanKeys,
          in_position_keys: postionDataArray.length > 0 ? convertIdsToCommaSeparatedString(postionDataArray) : "",
          in_user_tz: resDataObject[0].pref_value,
          in_final_pay_period: formFields.is_final_pay_period ? 1 : 0,
          in_proc_ctrl_mstr_key:
            DataItem.proc_ctrl_mstr_key !== undefined && DataItem.proc_ctrl_mstr_key !== null
              ? DataItem.proc_ctrl_mstr_key
              : 0,
        };

        if (formFields.is_recurring_type_job === true) {
          Action.addJobRecurringJobdataDataAsync(insertRecurringJobData);
        } else {
          Action.addJobQueueDataAsync(bodyData);
        }
        restProps.setIsAddJobtoQueue(false);
        if (restProps.module !== "job_execution") {
          setTimeout(() => {
            handleRedirect();
          }, 2000); // 10000 milliseconds (10 seconds
        }
        if (restProps.module === "job_execution") {
          setTimeout(() => {
            restProps.setIsJobqueueAdd(true);
          }, 2000); // 10000 milliseconds (10 seconds
        }
        // setSaveClick(false);
      }
    } else {
      setSaveClick(true);
    }
  };
  const handleChange = (e, props) => {
    if (props.onChange) {
      setIsPostionButton(false);
      props.onChange({
        dataItem: props.dataItem,
        field: props.field,
        syntheticEvent: e.syntheticEvent,
        value: e.target.value === true ? 1 : 0,
      });
      let finalData = filterData.isFilter ? processedData.data : postionData;
      const hasIsParamAssignOne = finalData.some((item) => item.is_assign === 1);
      if (hasIsParamAssignOne) {
        setIsPostionButton(false);
        setIsCompPlanDisable(true);
      } else {
        setIsPostionButton(true);
        setIsCompPlanDisable(false);
      }
      setIsCheckBoxChange(true);

      setkHeaderCheckbox();
      setIsAllDataChecked(true);
    }
  };

  const cellCheckboxOnChange = (e, props) => {
    if (props.onChange) {
      setIsPostionButton(false);
      props.onChange({
        dataItem: props.dataItem,
        field: props.field,
        syntheticEvent: e.syntheticEvent,
        value: e.target.value === true ? 1 : 0,
      });
      let finalData = filterData.isFilter ? processedData.data : postionData;

      const hasIsParamAssignOne = postionData.some((item) => item.is_assign === 1);
      if (hasIsParamAssignOne) {
        setIsPostionButton(false);
        setIsCompPlanDisable(true);
      } else {
        setIsPostionButton(true);
        setIsCompPlanDisable(false);
      }
      setIsCheckBoxChange(true);

      setkHeaderCheckbox();
      setIsAllDataChecked(true);
    }
  };

  const CheckboxCell = React.useCallback(
    (props) => {
      const { dataItem, render } = props;
      const hasIsParamAssignOne = postionData.some((item) => item.is_assign === 1);
      if (hasIsParamAssignOne) {
        setIsPostionButton(false);
      } else {
        setIsPostionButton(true);
      }

      let value = props.field + dataItem.rowId;
      const defaultRendering = (
        <td>
          <Checkbox
            value={dataItem[props.field] === 1 ? true : false}
            onChange={(e) => {
              cellCheckboxOnChange(e, props, value);
            }}
            autoComplete="off"
            name={`${props.field}`}
            disabled={isCompPostionButton ? false : true}
          />
        </td>
      );
      return render?.call(undefined, defaultRendering, props);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [postionData, isCompPostionButton]
  );

  const headerCheckboxOnChange = (e) => {
    setIsHeaderChecked(!isHeaderChecked);
    if (isHeaderChecked) {
      setIsCompPlanDisable(false);
    } else {
      setIsCompPlanDisable(true);
    }

    let finalData = filterData.isFilter ? filterBy(postionData, filterData.data) : postionData;

    finalData
      .filter((x) => x.is_assign === (isHeaderChecked ? 1 : 0))
      .map((item) => {
        setIsPostionButton(false);
        item.is_assign = !isHeaderChecked ? 1 : 0;
        item.inIteamEdit = true;
        if (isHeaderChecked) {
          item.inIteamEdit = false;
        }
        return 0;
      });

    // setDatabyFilter(finalData);
    // setPostionData(finalData);
  };

  const setkHeaderCheckbox = () => {
    let finalData = filterData.isFilter ? filterBy(postionData, filterData.data) : postionData;
    const ispositionChecked = postionData.length > 0 ? postionData[0].positionCount : "";

    if (!ispositionChecked && postionData.length !== 0) {
      showisPoistionIntialNote(true);
    } else {
      showisPoistionIntialNote(false);
    }
    // !ispositionChecked
    //   ? showisPoistionIntialNote(true)
    //   : showisPoistionIntialNote(false);

    setIsHeaderChecked(finalData.length ? !finalData.filter((x) => x.is_assign === 0).length : 0);
  };

  const usePostionCol = (columns) => {
    return columns.map((column, idx) => {
      if (column.field === "is_assign") {
        let writeAcess =
          restProps.module === "job_execution"
            ? restProps.pageProps.pageProps.pageProps.writeAccess
            : restProps.pageProps.pageProps.writeAccess;

        column["aditionalParam"] = {
          assignCheckboxProps: {
            checked: isHeaderChecked,
            onChange: headerCheckboxOnChange,
            disabled:
              postionData.length === 0 ||
              (filterData.isFilter && processedData.data.length === 0) ||
              writeAcess === 0 ||
              (isCompPostionButton ? false : true),
          },
          dataTableProps: {
            id: "is_assign",
          },
        };
      }

      return column.show && column.title !== "" ? (
        <Column
          {...columnMenuProps(column)}
          key={idx}
          // sortable={column.field === "is_assign" ? false : true}
          width={column.field === "is_assign" ? "130px" : column.minWidth}
          cell={column.field === "is_assign" ? CheckboxCell : ""}
          resizable={column.field === "is_assign" ? false : true}
          editable={false}
        />
      ) : (
        false
      );
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  };
  let PostionDataColumn = usePostionCol(postioncolumns);

  const customRowRender = (tr, props) => (
    <RowRender originalProps={props} tr={tr} editField={editField} exitEdit={exitEdit} />
  );
  const customCellRender = (td, props) => {
    return (
      <CellRender
        navigatable={true}
        originalProps={props}
        td={td}
        enterEdit={enterEdit}
        editField={editField}
        onRowClick={onRowClick}
        updateActBtn="grid-incell-update"
        cancelActBtn="grid-incell-cancel"
      />
    );
  };
  const onRowClick = () => { };

  const enterEdit = (dataItem, field) => {
    if (restProps.pageProps.writeAccess === 0) {
      return false;
    }

    let newData = postionData.map((item) => ({
      ...item,
      inEdit: item.org_position_key === dataItem.org_position_key ? field : undefined,
    }));

    setPostionData(newData);
  };
  const itemChange = React.useCallback(
    (event) => {
      //   restProps.setUnitEdit(true);
      const field = event.field || "";
      const newData = postionData.map((item) =>
        item.org_position_key === event.dataItem.org_position_key
          ? { ...item, [field]: event.value, inIteamEdit: true }
          : item
      );
      let editItem = event.dataItem;
      editItem[field] = event.value;
      setPostionData(newData);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [postionData]
  );
  const exitEdit = () => {
    let newData = data.map((item) => ({
      ...item,
      inEdit: undefined,
    }));
    setData(newData);
  };

  const getInSortNumber = () => {
    return filterData.isSort ? filterData.in_sort_number : DEFAULT_SORT.number;
  };

  const getInSortOrder = () => {
    return filterData.isSort ? filterData.sort_order : DEFAULT_SORT.order;
  };

  const getInFilter = () => {
    return filterData.isFilter ? filterData.filterString : null;
  };

  const handleStaticColumnMenu = (sortFieldData) => {
    let sortedData = sortFieldData.length === 0 ? sortFieldValue : sortFieldData;
    if (sortFieldData.length === 0) {
      sortedData[0].dir = "asc";
    }
    setSortFieldValue(sortFieldData);

    if (sortFieldData.length === 0 && sortFieldData[0] === undefined) {
      setResetSort(true);
      setGridState((prev) => ({
        ...prev,
        skip: 0,
        sort: [], // Clear sorting
      }));
    } else {
      // Otherwise, update the sort state
      setGridState((prev) => ({
        ...prev,
        sort: sortFieldData,
      }));
    }
  };

  const handlePostionColumnMenu = (filterAndSortData, issort) => {
    if (issort) {
      setDataCount(orderBy(postionData, filterAndSortData).length);

      setGridState((prev) => ({
        ...prev,
        sort: filterAndSortData,
        skip: pageData.skip,
        take: pageSize.recordTake,
      }));
      setFilterData({
        ...filterData,
        isSort: true,
        // data: filterAndSortData.filter,
        // isFilter: true,
        // in_sort_number: DEFAULT_SORT.number,
        // in_sort_order: DEFAULT_SORT.order,
        // filterString: filterString,
      });
    } else {
      let filterString = "";
      if (filterAndSortData.filter !== null) {
        filterString = getfilterDataString(filterAndSortData.filter.filters, postioncolumns);
      }
      setFilterData({
        ...filterData,
        // isSort: false,
        data: filterAndSortData.filter,
        isFilter: true,
        in_sort_number: DEFAULT_SORT.number,
        in_sort_order: DEFAULT_SORT.order,
        filterString: filterString,
      });
      setDatabyFilter(filterBy(postionData, filterAndSortData.filter));
      setIntialFilterCheck(true);
      setDataCount(filterBy(postionData, filterAndSortData.filter).length);
      setGridState((prev) => ({
        ...prev,
        filter: filterAndSortData.filter,
        skip: 0,
        // // skip: pageData.skip,
        // // take: pageData.take,
      }));
      setPage({ skip: 0, take: pageSize.recordTake });
    }
  };

  const getPostiongridData = async (inParams) => {
    Action.getPostionListDataAsync(inParams);
  };

  const onPostionClearFilter = () => {
    //set filter to false
    setFilterField({ logic: "and", filters: [] });
    setDatabyFilter(null);
    setFilterData({
      ...filterData,
      data: "",
      isFilter: false,
      filterString: "",
    });

    setGridState((prev) => ({
      ...prev,
      skip: 0,
      take: pageSize.recordTake, // Number of rows per page
      filter: null,
    }));
    setDataCount(originalData.length);
    setPage({ skip: 0, take: pageSize.recordTake });

    // getPostiongridData(dataVal);
  };

  const onPostionClearFilterForPeriod = () => {
    setDatabyFilter(null);
    setFilterData({
      ...filterData,
      data: "",
      isFilter: false,
      filterString: "",
    });

    setGridState({
      skip: 0,
      take: defaultPageSize.recordTake, // Number of rows per page
      filter: null, // Initial filter state
      sort: [],
    });
    setDataCount(originalData.length);
    setPage({ skip: 0, take: defaultPageSize.recordTake });
    setPageSize(defaultPageSize);
  };

  const onPostionRefreshClick = () => {
    setPostionAPICallingState(true);

    const postionReqData = {
      ...positionFilterData,
      in_period_mstr_key: periodsFields.periodsValue.id,
      in_filter: filterData.filterString,
      in_sort_number: getInSortNumber(),
      in_sort_order: getInSortOrder(),
    };

    getPostiongridData(postionReqData);
    setPostionAPICallingState(false);
  };
  const handlePageChange = async (event) => {
    const pageData = event.page;

    setPostionAPICallingState(true);

    setPage({ skip: pageData.skip, take: pageData.take });
    setPostionAPICallingState(false);
    setGridState((prev) => ({
      ...prev,
      skip: event.page.skip,
      take: event.page.take,
    }));
    setIntialFilterCheck(false);
    // setFilterData({
    //   ...filterData,
    //   data: "",
    //   isFilter: false,
    //   in_sort_number: DEFAULT_SORT.number,
    //   in_sort_order: DEFAULT_SORT.order,
    // });
  };

  React.useEffect(() => {
    if (formFields.is_recurring_type_job) {
      const height = getGridHeight();
      setGridHeight(height);
    } else {
      setGridHeight("auto");
    }
  }, [formFields.is_recurring_type_job]);

  const postionDataGrid = () => {
    // let gridHeight = formFields.is_recurring_type_job ? getGridHeight() : "auto"
    return (
      <>
        {/* <div className="content">
          {" "}
          <div className="content-head">
            <div className="Page-title">
              <h1>Position Assignment</h1>
            </div>
          </div>
        </div> */}
        {isRefreshLoading && loadingPanel}
        {postioncolumns.length > 0 ? (
          <DataTable
            isAPICalling={isPostionAPICalling}
            initialLoading={initialPostionLoading}
            resetSort={resetSort}
            // data={
            //   filterData.isFilter && databyFilter !== null
            //     ? sortFieldValue.length > 0
            //       ? filterBy(
            //           orderBy(originalData, sortFieldValue),
            //           filterData.data
            //         )
            //       : filterBy(originalData, filterData.data)
            //     : sortFieldValue.length > 0
            //     ? orderBy(paginatedData, sortFieldValue)
            //     : paginatedData
            // }
            data={processedData.data}
            id="job-postion-grid"
            editField={editField}
            pageData={pageData}
            dataCount={processedData.total}
            // dataCount={processedData.total}
            customColumn={PostionDataColumn}
            columns={postioncolumns}
            dataItemKey={"org_position_key"}
            gridHeight={gridHeight}
            module={"job-postion-grid"}
            fileName={"Export_job_configuration.xlsx"}
            exportData={exportData}
            rowRender={customRowRender}
            cellRender={customCellRender}
            itemChange={itemChange}
            defaultPageSize={defaultPageSize}
            pageSize={pageSize}
            setPageSize={setPageSize}
            handleColumnMenu={handlePostionColumnMenu}
            handlePageChange={handlePageChange}
            onClearFilter={onPostionClearFilter}
            // refreshClick={onPostionRefreshClick}
            reorderable={false}
            isFilterData={intialFilterCheck}
            isSortData={filterData.isSort}
            // setDataLengthbyFilter={setDataLengthbyFilter}
            // setDatabyFilter={setDatabyFilter}
            // noDataFound={paginatedData.length === 0 ? true : false}
            // isPagination={dataLengthbyFilter === 0 ? false : true}
            // setDataCount={setDataCount}
            originalDataCount={postionData.length}
            // setOriginalData={setOriginalData}
            // setPostionData={setPostionData}
            handleStaticColumnMenu={handleStaticColumnMenu}
            initialFilter={filterField}
            initialSort={sortField}
            stageChange={stageChange}
          />
        ) : (
          <>{loadingPanel}</>
        )}
      </>
    );
  };

  const handleStageChange = (e) => {
    setStateChange(e.state);
    if (e.state === "MINIMIZED") {
      setModal(false);
    } else if (e.state === "DEFAULT") {
      setModal(true);
    }
  };

  return (
    <>
      <Window
        title={<ModalTitle />}
        onClose={onClosePopup}
        width={930}
        // height={window.innerHeight * 0.8}
        // top={40}
        height={
          restProps.dataItemList.position_param === 1 ||
            restProps.dataItemList.published_position === 1 ||
            restProps.dataItemList.job_type_code === "email_process"
            ? formFields.is_recurring_type_job
              ? window.innerHeight * 0.92
              : isPoistionIntialNote
                ? window.innerHeight * 0.92
                : window.innerHeight * 0.92
            : 320
        }
        resizable={false}
        stage={stageChange}
        onStageChange={handleStageChange}
        modal={modal}
        className="addjobtoqueuecont"
      >
        <div className="dtu-file-container-logs">
          {/* <div className="content dtutitlebar"> */}
          <FormElement className="addjobquecont form-row" horizontal={true}>
            {" "}
            <FieldWrapper className="addjobque">
              <div className={"k-form-field-wrap-popup"}>
                <Label>{"Period Type* : "}</Label>
                <CustomDropdown
                  name={"periodTypeValue"}
                  data={periodsTypeFields.periodTypeData}
                  textField="text"
                  dataItemKey="id"
                  valueData={originPeriodType.find((c) => c.text === periodsTypeFields.periodTypeValue.text)}
                  onOpen={(dataValue) => {
                    setonOpenDp(true);
                    setPeriodTypeFields({
                      ...periodsTypeFields,
                      periodTypeData: originPeriodType,
                    });
                  }}
                  onChange={(e, name) => {
                    setonOpenDp(false);
                    setPeriodTypeFields({
                      ...periodsTypeFields,
                      [name]: e,
                    });
                    Action.getPeriodsData(e.id, e);
                  }}
                  onFilterChange={(dataValue) => {
                    setPeriodTypeFields({
                      ...periodsTypeFields,
                      periodTypeData: dataValue,
                    });
                  }}
                  filterable={true}
                  autoClose={false}
                  autoBind={true}
                  dataList={originPeriodType}
                  loading={periodsTypeFields.isPeriodTypeDataLoading}
                />
              </div>
              <div className={"k-form-field-wrap-popup"}>
                <Label>{"Period* : "}</Label>
                <CustomDropdown
                  name={"periodsValue"}
                  data={periodsFields.periodsData}
                  textField="text"
                  dataItemKey="id"
                  valueData={originPeriod.find((c) => c.text === periodsFields.periodsValue.text)}
                  onChange={(e, name) => {
                    setIsPeriodFilter(false);
                    setonOpenDp(false);
                    setPeriodFields({
                      ...periodsFields,
                      [name]: e,
                    });
                    setResetSort(true);

                    onPostionClearFilterForPeriod();
                    setPostionAPICallingState(true);
                    showisPoistionIntialNote(false);

                    // handleChangePeriod();
                  }}
                  onOpen={(dataValue) => {
                    setonOpenDp(false);
                    setPeriodFields({
                      ...periodsFields,
                      periodsData: dataValue,
                    });
                  }}
                  filterable={true}
                  onFilterChange={(dataValue) => {
                    setIsPeriodFilter(true);
                    setPeriodFields({
                      ...periodsFields,
                      periodsData: dataValue,
                    });
                  }}
                  autoClose={false}
                  autoBind={true}
                  isSelectALl={true}
                  dataList={originPeriod}
                  loading={periodsFields.isPeriodDataLoading}
                />
              </div>{" "}
              <div className={"k-form-field-wrap-popup"}>
                <label>Start Date *:</label>
                <DatePicker
                  value={formFields.in_start_date}
                  onChange={handleDateChange}
                  format="yyyy-MM-dd"
                  placeholder="yyyy-mm-dd"
                />
                <ShowError name={"in_start_date"}></ShowError>
              </div>
              <div className={"k-form-field-wrap-popup"}>
                <label>Start time *:</label>
                <TimePicker
                  value={formFields.in_start_time}
                  onChange={(e) => {
                    setFormFields({
                      ...formFields,
                      in_start_time: e.target.value,
                    });
                    // Action.getPeriodsData(e.id, e);
                  }}
                  // format={{
                  //   hour: "2-digit",
                  //   minute: "2-digit",
                  // }}
                  // nowButton={true}
                  steps={{
                    minute: 15,
                  }}
                />
                <ShowError name={"in_start_time"}></ShowError>
              </div>
              <div className={"k-form-field-addrecujob"}>
                <label>Recurring Job? :</label>
                <Checkbox
                  value={formFields.is_recurring_type_job}
                  onChange={handleRecurringCheckboxChange}
                  name="is_recurring_type_job"
                />
              </div>
              {!formFields.is_recurring_type_job && restProps.dataItemList.is_populate_final_pay_period > 0 && (
                <div className={"k-form-field-addrecujob"}>
                  <label>Final Pay Period? :</label>
                  <Checkbox
                    value={formFields.is_final_pay_period}
                    onChange={handleFinalPayPeriod}
                    name="is_final_pay_period"
                  />
                </div>
              )}
              {restProps.dataItemList.job_type_code === "stage_hook" && restProps.dataItemList.plan_param === 1 ? (
                <div className={"k-form-field-wrap-popup valueDropdown"}>
                  <Label>{"Comp Plan*: "}</Label>
                  <MultiSelectDropdown
                    name={"compPlanValue"}
                    data={compPlanFields.compPlanData}
                    textField="text"
                    dataItemKey="id"
                    // valueData={originCompPlan.find(
                    //   (c) => c.text === compPlanFields.compPlanValue.text
                    // )}
                    valueData={formFields.compPlanValue}
                    onOpen={(dataV) => {
                      setcompPlanFields({
                        ...compPlanFields,
                        compPlanData: dataV,
                      });
                    }}
                    onChange={(e, name) => {
                      setFormFields({
                        ...formFields,
                        [name]: e,
                      });
                      setcompPlanFields({
                        ...compPlanFields,
                        compPlanValue: e,
                      });
                      e.length !== 0 ? setIsCompPostionButton(false) : setIsCompPostionButton(true);
                      setErrorObj({ ...errorObj, [name]: "" });
                      // Action.getPeriodsData(e.id, e);
                    }}
                    onFilterChange={(dataValue) => {
                      setcompPlanFields({
                        ...compPlanFields,
                        compPlanData: dataValue,
                      });
                    }}
                    filterable={true}
                    autoClose={false}
                    autoBind={true}
                    dataList={originCompPlan}
                    loading={compPlanFields.iscompPlanDataLoading}
                    placeholder={"Select Comp Plan"}
                    disabled={isCompPlanDisable}
                  />
                  <ShowError name={"compPlanValue"}></ShowError>
                </div>
              ) : (
                false
              )}
              {isRecurringTypeListshow ? (
                <>
                  <div
                    className={"k-form-field-wrap-popup"}
                  // style={{ marginTop: "50px" }}
                  >
                    {/* <Label>{"End:"}</Label> */}
                    {/* <div style={{ marginTop: "5px" }}>
                        {" "}
                        <RadioButton
                          name="never"
                          value="never"
                          checked={formFields.is_repet_job === "never"}
                          label="Never"
                          onChange={handleRadioButtonChange}
                        />
                      </div>
                      <div style={{ marginTop: "5px" }}>
                        {" "}
                        <RadioButton
                          name="on"
                          value="on"
                          checked={formFields.is_repet_job === "on"}
                          label="On"
                          onChange={handleRadioButtonChange}
                        /> */}
                    <div>
                      <label>End Date*:</label>
                      <DatePicker
                        // disabled={
                        //   formFields.is_repet_job === "on" ? false : true
                        // }
                        value={formFields.in_recurring_end_date}
                        name="in_recurring_end_date"
                        format="yyyy-MM-dd"
                        onChange={(e) => {
                          handleRecurringDateChange(e);
                        }}
                        formatPlaceholder={{
                          year: "yyyy",
                          month: "mm",
                          day: "dd",
                        }}
                        placeholder="yyyy-mm-dd"
                      />
                      <ShowError name={"in_recurring_end_date"}></ShowError>
                    </div>
                  </div>
                  <div className={"k-form-field-wrap-popup repeateeveryboxcont"}>
                    <Label className="repeateeveryboxlabel">{"Repeat every:"}</Label>
                    <div className="repeateeverybox">
                      <NumericTextBox
                        name="in_separation_count"
                        value={formFields.in_separation_count}
                        onChange={(e) => {
                          handleFieldChange(e);
                        }}
                        min={1}
                        autoFocus={true}
                      />
                      <CustomDropdown
                        name={"recurringTypeValue"}
                        data={recurringTypeFields.recurringTypeData}
                        textField="text"
                        dataItemKey="id"
                        valueData={originRecurringType.find(
                          (c) => c.text === recurringTypeFields.recurringTypeValue.text
                        )}
                        onOpen={(dataValue) => {
                          setRecurringTypeFields({
                            ...recurringTypeFields,
                            recurringTypeData: dataValue,
                          });
                        }}
                        onChange={(e, name) => {
                          setRecurringTypeFields({
                            ...recurringTypeFields,
                            [name]: e,
                          });
                          setFormFields({
                            ...formFields,
                            in_day_of_month: 1,
                            in_month_of_year: MONTH_OF_YEAR[0],
                          });
                          setSelectedDays([]);
                          if (e.text === "Weeks") {
                            setIsRecurringTypeWeekly(true);
                            setIsRecurringTypeMonthly(false);
                            setIsRecurringTypeYearly(false);
                          } else if (e.text === "Month") {
                            setIsRecurringTypeWeekly(false);
                            setIsRecurringTypeMonthly(true);
                            setIsRecurringTypeYearly(false);
                          } else if (e.text === "Year") {
                            setIsRecurringTypeWeekly(false);
                            setIsRecurringTypeMonthly(false);
                            setIsRecurringTypeYearly(true);
                          } else {
                            setIsRecurringTypeWeekly(false);
                            setIsRecurringTypeMonthly(false);
                            setIsRecurringTypeYearly(false);
                          }
                        }}
                        onFilterChange={(dataValue) => {
                          setRecurringTypeFields({
                            ...recurringTypeFields,
                            recurringTypeData: dataValue,
                          });
                        }}
                        filterable={true}
                        autoClose={false}
                        autoBind={true}
                        dataList={originRecurringType}
                        loading={recurringTypeFields.isRecurringTypeDataLoading}
                      />
                    </div>
                  </div>
                  {isRecurringTypeWeekly ? (
                    <div className={"k-form-field-wrap-jobque"}>
                      <Label>{"Days of (Week):"}</Label>
                      <ButtonGroup>
                        {DAYS_OF_WEEK.map((item) => (
                          <Button
                            key={item.value}
                            togglable={true}
                            onClick={(event) => {
                              event.preventDefault(); // Prevent default form submission
                              weekButtonClick(item.value);
                            }}
                            active={isDaySelected(item.value)}
                            style={{
                              backgroundColor: isDaySelected(item.value) ? "#00a1e4" : "inherit",
                              color: isDaySelected(item.value) ? "#fff" : "inherit",
                            }} // Change the background color if selected
                          >
                            {item.text}
                          </Button>
                        ))}
                      </ButtonGroup>
                    </div>
                  ) : (
                    false
                  )}
                  {isRecurringTypeYearly ? (
                    <div className={"k-form-field-wrap-popup"}>
                      <Label>{"Month of Year:"}</Label>
                      <div>
                        <DropDownList
                          // onChange={(e) =>
                          //   setFormFields({
                          //     ...formFields,
                          //     in_month_of_year: e.target.value,
                          //   })
                          // }
                          onChange={handleMonthChange}
                          value={formFields.in_month_of_year}
                          data={MONTH_OF_YEAR}
                          dataItemKey="value"
                          textField="text"
                          placeholder={"Select"}
                        />
                      </div>
                    </div>
                  ) : (
                    false
                  )}
                  {isRecurringTypeMonthly || isRecurringTypeYearly ? (
                    <div className={"k-form-field-wrap-popup"}>
                      <Label>{"Day of Month:"}</Label>
                      <NumericTextBox
                        name="in_day_of_month"
                        placeholder="Repeat on"
                        min={1}
                        max={maxDays}
                        value={formFields.in_day_of_month}
                        onChange={(e) => {
                          handleFieldChange(e);
                        }}
                        autoFocus={true}
                      />
                      <ShowError name={"in_day_of_month"}></ShowError>
                    </div>
                  ) : (
                    false
                  )}
                </>
              ) : (
                false
              )}
            </FieldWrapper>
            {isPoistionIntialNote && !compPlanFields?.compPlanValue?.length ? (
              <FieldWrapper>NOTE : Below positions are running for the first time.</FieldWrapper>
            ) : (
              false
            )}
          </FormElement>
          {/* </div> */}
        </div>
        {restProps.dataItemList.position_param === 1 ||
          restProps.dataItemList.published_position === 1 ||
          restProps.dataItemList.job_type_code === "email_process"
          ? postionDataGrid()
          : false}
        <WindowActionsBar layout={"end"}>
          <Button
            className="primarybtn"
            onClick={(e) => {
              handleAddJobtoQueue();
            }}
            autoFocus={true}
            disabled={
              restProps.dataItemList.job_type_code === "email_process"
                ? processedData.data.length === 0
                : restProps.dataItemList.position_param === 1 && processedData.data.length === 0
            }
          >
            {"Add"}
          </Button>
          <Button
            className="cancelbtn"
            onClick={(e) => {
              onClosePopup();
            }}
            autoFocus={true}
          >
            {"Cancel"}
          </Button>
        </WindowActionsBar>
      </Window>
      {positionPopup ? (
        <Dialog title={"Alert"} id="dialog-timeout" width={550}>
          <p
            style={{
              margin: "25px",
              textAlign: "center",
            }}
          >
            <img
              src={require("../../images/alert.png").default}
              alt="ProCARE"
              style={{ height: "25px" }} // Fixed the height value
            />{" "}
            Please Select Position
          </p>
          <DialogActionsBar layout="center">
            <button
              className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
              onClick={cancelPositionPopup}
            >
              OK
            </button>
          </DialogActionsBar>{" "}
        </Dialog>
      ) : (
        false
      )}
    </>
  );
};
export default React.memo(JobDetails);
